import styled from 'styled-components';

const PasswordWrapper = styled.div`
  position: relative;
  margin-top: 0.25rem;
`;

export default PasswordWrapper;